import { SubItemAccordion } from '@domain/_screens/workflow/automatic-card/generic-automatic-card/accordion/accordion.types';
import React, { Fragment, useState } from 'react';
import RoundedSquareAccordionItem from './RoundedSquareAccordionItem';

const defaultProps = {
    onChange: null,
    expandedAccordion: null,
    renderContent: undefined,
};

interface Props {
    accordionItems: Array<SubItemAccordion>,
    onChange: () => void,
    renderContent: () => void,
    expandedAccordion?: string,
}

const RoundedSquareAccordion = ({
    accordionItems,
    onChange,
    renderContent,
    expandedAccordion,
}: Props) => {
    const [activeItem, setActiveItem] = useState(expandedAccordion);
    return (
        <Fragment>
            {accordionItems.map(item => (
                <RoundedSquareAccordionItem
                    item={item}
                    activeItem={activeItem}
                    setActiveItem={setActiveItem}
                    key={item.id}
                    onChange={onChange}
                    renderContent={renderContent}
                />
            ))}
        </Fragment>
    );
};

RoundedSquareAccordion.defaultProps = defaultProps;

export default RoundedSquareAccordion;
